// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"PropellLogoCoal900_loaderContainer__1I2IY","st1":"PropellLogoCoal900_st1__1Zgi0","st0":"PropellLogoCoal900_st0__35ecL"};